export default __webpack_public_path__ + "static/media/default-icon.7d5391d2.svg";